/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetDeliveryResponseDtoParticipationEntitlementsInner } from './get-delivery-response-dto-participation-entitlements-inner';

/**
 * 
 * @export
 * @interface UpdateDeliveryDestinationResponseDto
 */
export interface UpdateDeliveryDestinationResponseDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'deletedAt': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'participationId': string;
    /**
     * Event/Challenge title associated with this delivery
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'eventName'?: string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationStreet': string;
    /**
     * Additional destination address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationAddressLine2'?: string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for destination address data
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationSourceApi': UpdateDeliveryDestinationResponseDtoDestinationSourceApiEnum;
    /**
     * Origin name
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'originSourceApi'?: UpdateDeliveryDestinationResponseDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'status': UpdateDeliveryDestinationResponseDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Whether finisher shirt is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'shouldIncludeFinisherShirt'?: boolean;
    /**
     * Finisher shirt size if included
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'finisherShirtSize'?: string;
    /**
     * Whether medal is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'shouldIncludeMedal'?: boolean;
    /**
     * List of entitlements included in this delivery
     * @type {Array<GetDeliveryResponseDtoParticipationEntitlementsInner>}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'participationEntitlements'?: Array<GetDeliveryResponseDtoParticipationEntitlementsInner>;
    /**
     * Destination recipient name (who will receive the package)
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationRecipient'?: string;
    /**
     * Destination contact number
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationContact'?: string;
    /**
     * Complete destination address (street, address line 2, barangay, city, province, postal code, country)
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'destinationAddress'?: string;
    /**
     * User nickname from participation
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'userNickname'?: string;
    /**
     * User full name from participation
     * @type {string}
     * @memberof UpdateDeliveryDestinationResponseDto
     */
    'userFullName'?: string;
}

export const UpdateDeliveryDestinationResponseDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryDestinationResponseDtoDestinationSourceApiEnum = typeof UpdateDeliveryDestinationResponseDtoDestinationSourceApiEnum[keyof typeof UpdateDeliveryDestinationResponseDtoDestinationSourceApiEnum];
export const UpdateDeliveryDestinationResponseDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryDestinationResponseDtoOriginSourceApiEnum = typeof UpdateDeliveryDestinationResponseDtoOriginSourceApiEnum[keyof typeof UpdateDeliveryDestinationResponseDtoOriginSourceApiEnum];
export const UpdateDeliveryDestinationResponseDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type UpdateDeliveryDestinationResponseDtoStatusEnum = typeof UpdateDeliveryDestinationResponseDtoStatusEnum[keyof typeof UpdateDeliveryDestinationResponseDtoStatusEnum];


